<template>
  <el-dialog
    title="设置代理"
    :visible.sync="dialogVisible"
    customClass="customWidth"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="mini"
    >
      <el-form-item
        prop="legal"
        label="微信呢称"
      >
        {{userName}}
      </el-form-item>
      <el-form-item
              prop="legal"
              label="姓名"
      >
        {{legal}}
      </el-form-item>
      <el-form-item
        prop="userName"
        label="代理级别"
      >
        <div v-if="agenttype=='1'">
          普通用户
        </div>
        <div v-else-if="agenttype=='2'">
          <div v-if="dl_type=='-1'">
            平台
          </div>
          <div v-else-if="dl_type=='0'">
            全国代理
          </div>
          <div v-else-if="dl_type=='1'">
            运营商
          </div>
          <div v-else-if="dl_type=='2'">
            服务商
          </div>
          <div v-else-if="dl_type=='5'">
            运营中心
          </div>

        </div>
      </el-form-item>
      <el-form-item
        prop="prov_cd"
        label="升级为"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.prov_cd"
                placeholder="请选择"

        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>




    <el-form-item>
      <el-button
              type="primary"
              :loading="loading"
              @click="saveUser"
      >保存</el-button>
      <el-button @click="close">取消</el-button>
    </el-form-item>
    </el-form>
  </el-dialog>

</template>
<style>
  .customWidth{
    width:80%;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js';
export default {
  name: "twoagentyEditForm",
  props: {
      oneagent: Object,
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
        userName:"",
      legal:"",
      agenttype:"",
      dl_type:"",
      form: {
          prov_cd:""
      },
        typeOptions: [   {
            value: "0",
            label: "全国代理"
        },{
          value: "5",
          label: "运营中心"
        },{
          value: "1",
          label: "运营商"
        },{
          value: "2",
          label: "服务商"
        },{
          value: "6",
          label: "普通用户"
        }]
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {

    dialogOpen() {
      this.$refs.form.resetFields();
      if (this.oneagent.userId) {

          this.userName = this.oneagent.agentname;
        this.legal = this.oneagent.legal;
        this.agenttype= this.oneagent.agenttype;
        this.dl_type=this.oneagent.dl_type;
      } else {
        this.form = {};
      }

    },
      saveUser() {
          this.$refs["form"].validate(valid => {
              if (valid) {
                  if (this.oneagent.userId) {
                      this.loading = true;
                      agentService.saveDltype({ ...this.form,agentid:this.oneagent.agentid,dl_gl:this.oneagent.dl_type,kkk:1})
                          .then(data => {
                              this.loading = false;
                              this.dialogVisible = false;
                              this.$emit("submit");
                          });
                  }
              } else {
                  return false;
              }
          });
      },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

